import { render, staticRenderFns } from "./FlatBarSettings.vue?vue&type=template&id=12265016&"
import script from "./FlatBarSettings.vue?vue&type=script&lang=js&"
export * from "./FlatBarSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports